import {
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { Button } from 'components/v4';

const ConfirmationDialog = ({
    isOpen = false,
    onClose = () => {},
    onConfirm = () => {},
    title = 'Confirm Action',
    message = 'Are you sure you want to proceed?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    confirmColorScheme,
    isLoading = false,
    // Lets a caller gate the confirm behind an acknowledgement rendered in
    // `message` — off by default, so existing callers are unaffected.
    isConfirmDisabled = false,
    ...props
}) => {
    const { darkMode } = useSelector((state) => state.settings);

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <AlertDialog isOpen={isOpen} onClose={onClose} {...props}>
            <AlertDialogOverlay
                bg={darkMode ? 'blackAlpha.600' : 'blackAlpha.300'}>
                <AlertDialogContent
                    bg={darkMode ? 'gray.800' : 'white'}
                    color={darkMode ? 'white' : 'gray.900'}
                    borderColor={darkMode ? 'gray.600' : 'gray.200'}>
                    <AlertDialogHeader
                        fontSize="lg"
                        fontWeight="bold"
                        color={darkMode ? 'white' : 'gray.900'}>
                        {title}
                    </AlertDialogHeader>

                    <AlertDialogBody color={darkMode ? 'gray.100' : 'gray.700'}>
                        {message}
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button
                            onClick={onClose}
                            variant="outline"
                            isDisabled={isLoading}>
                            {cancelText}
                        </Button>
                        <Button
                            onClick={handleConfirm}
                            colorScheme={confirmColorScheme}
                            ml={3}
                            isDisabled={isConfirmDisabled}
                            isLoading={isLoading}>
                            {confirmText}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
};

export default ConfirmationDialog;
